import axios from "axios";
import config from "../../../settings/config";
import { handleError } from "../../../network/servicErrorHandling";

async function shopTerms(uid) {
  return Promise.resolve().then((v) =>
    axios
      .get(`${config.baseUrl}v1/shops/${uid}/extra-descriptions`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function termDetail(uid, id) {
  return Promise.resolve().then((v) =>
    axios
      .get(`${config.baseUrl}v1/shops/${uid}/extra-descriptions/${id}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function termDetailSave(uid, params) {
  return Promise.resolve().then((v) =>
    axios
      .post(`${config.baseUrl}v1/shops/${uid}/extra-descriptions`, params)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function editTermDetail(uid, id, params) {
  return Promise.resolve().then((v) =>
    axios
      .put(`${config.baseUrl}v1/shops/${uid}/extra-descriptions/${id}`, params)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function deleteTerm(uid, id) {
  return Promise.resolve().then((v) =>
    axios
      .delete(`${config.baseUrl}v1/shops/${uid}/extra-descriptions/${id}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function shopTermsMore() {
  return Promise.resolve().then((v) =>
    axios
      .get(
        `${config.baseUrl}v1/terms-of-use/sections/seller-extra_des-and-terms/items`
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

export {
  shopTerms,
  termDetail,
  termDetailSave,
  editTermDetail,
  deleteTerm,
  shopTermsMore,
};
